import { createAsyncThunk } from "@reduxjs/toolkit";
import { savePostToFirebase } from "../../../pages/auth/utils/firebase/userOperations";

export const createPost = createAsyncThunk(
  "posts/createPost",
  async (post, { rejectWithValue, requestId }) => {
    try {
      const savedPost = await savePostToFirebase({
        ...post,
        clientRequestId: requestId,
      });
      return savedPost;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
